'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = salesPro;

var _immutable = require('immutable');

var _HubspotSalesSignupActionTypes = require('../actionTypes/HubspotSalesSignupActionTypes');

var initialState = new _immutable.Map({
  hasSalesPro: null
});

function salesPro() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case _HubspotSalesSignupActionTypes.PRO_STATUS_FETCHED:
      return state.merge(payload);

    default:
      return state;
  }
}
module.exports = exports['default'];